import { StreamingIndicator } from '~/features/chat/components/chat-message/streaming-indicator';

import { AssistantMarkdown } from './assistant-markdown';

interface AssistantTextMessageProps {
  text: string;
  /** When true, show the animated "generating" dots. Set while the LLM stream is active. */
  streaming?: boolean | undefined;
}

/**
 * LLM Q&A answer rendered as Markdown inside a subtle bubble — bold, italics,
 * lists, code, etc. format live as tokens arrive. The "generating" dots show
 * while the stream is active, including before the first token (where the
 * bubble is the only "thinking" affordance).
 */
export function AssistantTextMessage({ text, streaming = false }: AssistantTextMessageProps) {
  return (
    <div className="bg-muted/40 space-y-1 rounded-xl p-3">
      {text !== '' ? <AssistantMarkdown text={text} /> : null}
      {streaming ? <StreamingIndicator /> : null}
    </div>
  );
}
